<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect y="20" width="10" height="20" rx="0.638889" transform="rotate(-90 0 20)" fill="currentColor" />
        <path
            d="M20 3.49691e-06C20 1.31322 19.7413 2.61358 19.2388 3.82684C18.7362 5.04009 17.9997 6.14249 17.0711 7.07107C16.1425 7.99966 15.0401 8.73625 13.8268 9.2388C12.6136 9.74134 11.3132 10 10 10C8.68678 10 7.38642 9.74134 6.17316 9.2388C4.95991 8.73625 3.85751 7.99965 2.92893 7.07107C2.00034 6.14248 1.26375 5.04009 0.761202 3.82683C0.258655 2.61358 -2.09287e-06 1.31322 -1.74846e-06 -9.53674e-07L10 1.74846e-06L20 3.49691e-06Z"
            fill="currentColor" />
    </svg>
</template>
